module.exports = __webpack_public_path__ + "static/media/ic-modal-sync.627e1594.svg";